import React from "react";
import AppRoutes from "./Routes/Routes";
import { DrawerProvider } from "./Screens/Drawer/DrawerContext";
import { TranslationProvider } from "./TranslationProvider";
function App() {
  return (
    <div className="App">
      {/* Initializes react-i18next. Without this, any screen that calls
          useTranslation() throws and the page renders blank. */}
      <TranslationProvider>
        <DrawerProvider>
          <AppRoutes />
        </DrawerProvider>
      </TranslationProvider>
    </div>
  );
}

export default App;
